export const canReport = (iniDate,props) => {
    console.log(props)
    const perfiles = [0,15,17,18,19]
    const iPerfil = props.selectedCentroProfile.iPerfil;
    const fechaLimite = new Date();
    fechaLimite.setDate(new Date().getDate() - 14);
    return perfiles.includes(iPerfil) || fechaLimite <= new Date(iniDate);
}

export const enabledReport = (iniDate,props) => {
    const perfiles = [0,15,17,18,19]
    const iPerfil = props.userProfile.selectedCentroProfile.iPerfil;
    const fechaLimite = new Date();
    fechaLimite.setDate(new Date().getDate() - 14);
    return perfiles.includes(iPerfil) || fechaLimite <= new Date(iniDate);
}




export const fusionarItemsCaja = (datos) => {
  const prioridadZona = {
    "Bolera": 1,
    "Bar": 2,
    "Cumpleaños": 3,
    "Parque Infantil": 4,
    "Billares / Otros Juegos": 5,
    "Arcade": 6,
    "Maq.Cambio": 7,
    "General": 8
  };

  const cajaMain = datos.find(d => d.caja === "Caja Bolera/Kids");

  const fusionado = datos.map(item => {
    if (item.caja === "Caja Bar") {
      return {
        ...item,
        cajaId: (cajaMain && cajaMain.cajaId) || item.cajaId,
        caja: (cajaMain && cajaMain.caja) || item.caja,
      };
    }
    return item;
  });

  return fusionado
    .map((item, index) => ({ ...item, _index: index }))
    .sort((a, b) => {
      const pA = prioridadZona[a.zona] || 99;
      const pB = prioridadZona[b.zona] || 99;

      if (pA !== pB) return pA - pB;

      return a._index - b._index; // mantiene orden interno
    })
    .map(({ _index, ...item }) => item);
};

export const orderZonas = (datos) => {
  const prioridadZona = {
    "Bolera": 1,
    "Bar": 2,
    "Cumpleaños": 3,
    "Parque Infantil": 4,
    "Billares / Otros Juegos": 5,
    "Arcade": 6,
    "Maq.Cambio": 7,
    "General": 8
  };

  return datos
    .map((item, index) => ({ ...item, _index: index }))
    .sort((a, b) => {
      const pA = prioridadZona[a.zona] || 99;
      const pB = prioridadZona[b.zona] || 99;

      if (pA !== pB) return pA - pB;

      return a._index - b._index; // mantiene orden interno
    })
    .map(({ _index, ...item }) => item);
};
